import React from 'react';

const MetamaskIcon = () => {
  return (
    <svg width="26" height="24" viewBox="0 0 26 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.43854 22.06L10.845 22.9941V21.7725L11.1231 21.4851H13.0696V22.9222V23.9282H10.9841L8.4118 22.7785L7.43854 22.06Z"
        fill="#CDBDB2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.5615 22.06L15.2245 22.9941V21.7725L14.9465 21.4851H12.9999V22.9222V23.9282H15.0855L17.6577 22.7785L18.5615 22.06Z"
        fill="#CDBDB2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.123 19.4013L10.845 21.7725L11.1925 21.4851H14.8075L15.2246 21.7725L14.9465 19.4013L14.3904 19.042L11.6096 19.1139L11.123 19.4013Z"
        fill="#393939"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.24603 3.3772L10.9145 7.40114L11.6793 19.1137H14.3904L15.2247 7.40114L16.7541 3.3772H9.24603Z"
        fill="#F89C35"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.94653 12.2155L0 18.0358L4.86633 17.7484H7.99463V15.2335L7.85559 10.0598L7.1604 10.6347L1.94653 12.2155Z"
        fill="#F89D35"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.63098 12.8623L11.3315 13.006L10.7059 16.024L7.99463 15.3054L5.63098 12.8623Z"
        fill="#D87C30"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.63098 12.9343L7.99463 15.2337V17.5331L5.63098 12.9343Z"
        fill="#EA8D3A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.99463 15.3054L10.7754 16.024L11.6792 19.1139L11.0535 19.4731L7.99463 17.6048V15.3054Z"
        fill="#F89D35"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.99469 17.6047L7.43854 22.0598L11.1231 19.4012L7.99469 17.6047Z"
        fill="#EB8F35"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.3315 13.0059L11.6792 19.1137L10.6364 15.9879L11.3315 13.0059Z"
        fill="#EA8E3A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.79669 17.6767L7.99457 17.6047L7.43842 22.0598L4.79669 17.6767Z"
        fill="#D87C30"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.52942 23.9998L7.43848 22.0597L4.79675 17.6765L0 18.0357L1.52942 23.9998Z"
        fill="#EB8F35"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.9144 7.40112L7.92517 9.98794L5.63098 12.8622L11.3315 13.0778L10.9144 7.40112Z"
        fill="#E8821E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.43854 22.0597L11.1231 19.4011L10.845 21.7005V22.9939L8.34235 22.4909L7.43854 22.0597Z"
        fill="#DFCEC3"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.5615 22.0597L14.9465 19.4011L15.2245 21.7005V22.9939L17.7272 22.4909L18.5615 22.0597Z"
        fill="#DFCEC3"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.80206 14.2993L10.5668 15.9521L7.85553 15.2335L9.80206 14.2993Z"
        fill="#393939"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.45984 0.000244141L10.9144 7.40136L9.31555 3.37742L1.45984 0.000244141Z"
        fill="#E88F35"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.4599 0L0.208557 3.95209L0.903748 8.26345L0.417114 8.55088L1.1123 9.19758L0.556152 9.70057L1.32086 10.4191L0.834229 10.8503L1.94653 12.2874L7.16046 10.6347C9.70949 8.52692 10.9608 7.44908 10.9145 7.40118C10.8681 7.35327 7.71661 4.88621 1.4599 0Z"
        fill="#8E5A30"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.0535 12.2155L26 18.0358L21.1337 17.7484H18.0054V15.2335L18.1444 10.0598L18.8396 10.6347L24.0535 12.2155Z"
        fill="#F89D35"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.369 12.8623L14.6685 13.006L15.2941 16.024L18.0054 15.3054L20.369 12.8623Z"
        fill="#D87C30"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.369 12.9343L18.0054 15.2337V17.5331L20.369 12.9343Z"
        fill="#EA8D3A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.0054 15.3054L15.2246 16.024L14.3208 19.1139L14.9465 19.4731L18.0054 17.6048V15.3054Z"
        fill="#F89D35"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.0053 17.6047L18.5615 22.0598L14.9465 19.473L18.0053 17.6047Z"
        fill="#EB8F35"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.6685 13.0059L14.3208 19.1137L15.3636 15.9879L14.6685 13.0059Z"
        fill="#EA8E3A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.2033 17.6767L18.0054 17.6047L18.5616 22.0598L21.2033 17.6767Z"
        fill="#D87C30"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.4706 23.9998L18.5615 22.0597L21.2032 17.6765L26 18.0357L24.4706 23.9998Z"
        fill="#EB8F35"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.0856 7.40112L18.0748 9.98794L20.369 12.8622L14.6685 13.0778L15.0856 7.40112Z"
        fill="#E8821E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.1979 14.2993L15.4332 15.9521L18.1445 15.2335L16.1979 14.2993Z"
        fill="#393939"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.5402 0.000244141L15.0856 7.40136L16.6844 3.37742L24.5402 0.000244141Z"
        fill="#E88F35"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.5401 0L25.7914 3.95209L25.0963 8.26345L25.5829 8.55088L24.8877 9.19758L25.4438 9.70057L24.6791 10.4191L25.1658 10.8503L24.0535 12.2874L18.8395 10.6347C16.2905 8.52692 15.0392 7.44908 15.0855 7.40118C15.1319 7.35327 18.2834 4.88621 24.5401 0Z"
        fill="#8E5A30"
      />
    </svg>
  );
};

export default MetamaskIcon;
